/**
 * Doc Node Extension
 * 文档根节点
 */

import type { NodeSpec } from '../../core/types';
import { NodeExtension } from '../../core/Extension';

export class Doc extends NodeExtension {
  get name(): string {
    return 'doc';
  }

  get schema(): NodeSpec {
    return {
      content: 'block+',
    };
  }
}
